import { addToken } from "../APIKit";
import { API_URL } from "../constants";
import APIKit from "../APIKit";

function profileUpdatecall(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }
    APIKit.post("/update_profile", payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function addCertificate(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }
    APIKit.post("/add_certificates", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function changepasswordCall(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/change_password", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function removeCertificate(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/remove_certificates", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function kyc(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/upload_id_proof", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function kycPanGstUpload(payload,idprooftype) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    let kycurl = "/kyc_verification";
    if(idprooftype==3){
      kycurl = "/aadhar_verify";
    }
    

    APIKit.post(kycurl, payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function verifyKycStatus(payload,idprooftype) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    let kycurl = "/verify_aadhar_status";
   
    APIKit.post(kycurl, payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function kycAadharCaptcha(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }
    
    APIKit.post("/aadhar_captcha", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function kycAadharVerifyOTP(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

   
    let kycurl = "/aadhar_verify_otp";
    

    APIKit.post(kycurl, payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function kycSampleVideo(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }
    
    APIKit.post("/get_sample_kyc_videos", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function initiateAadhaarVerification(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/initiate_adhaar_verification", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function emailPhone(payload,api_url) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post(api_url, payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function profile(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/user_detailed_history", payload)
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function profileData(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/profile_list", payload, {
      headers: { "content-type": "multipart/form-data" },
    })
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {

          reject(e);
        }
      })
      .catch((err) => {

        reject(err);
      });
  });
}

function deleteProfile(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/delete_account", payload, {
      headers: { "content-type": "multipart/form-data" },
    })
      .then(async (response) => {
        try {

          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}



function fetchAadhaarDetails(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/fetch_adhaar_details", payload)
      .then(async (response) => {
        try {
          

          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function kycVideoUpload(payload) {

  return new Promise(async (resolve, reject) => {
    try {
      payload.append("auth_token", window.localStorage.getItem("auth_token"));
    } catch (e) {
    }

    APIKit.post("/kyc_video_upload", payload, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(async (response) => {
        try {
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const profileUpdateService = {
  profileUpdatecall,
  changepasswordCall,
  addCertificate,
  removeCertificate,
  kyc,
  kycPanGstUpload,
  verifyKycStatus,
  kycAadharVerifyOTP,
  kycSampleVideo,
  kycAadharCaptcha,
  initiateAadhaarVerification,
  fetchAadhaarDetails,
  kycVideoUpload,
  emailPhone,
  profile,
  profileData,
  deleteProfile,
};
